import { render, staticRenderFns } from "./NgList.vue?vue&type=template&id=f4197d3e&scoped=true&"
import script from "./NgList.vue?vue&type=script&lang=js&"
export * from "./NgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4197d3e",
  null
  
)

export default component.exports